export enum GlobalSettingsKeys {
  // The themes key was named with OpenUI prefix and we will have to retain it
  // for the sake of hybrid applications.
  THEMES_KEY = 'OpenUI.Theme.Default',

  // Cannot fix this value typo in NOVA since the same is used in UI5 apps.
  USER_SUPPRESSED_MESSAGES = 'HTML.USER_SUPPRESED_MESSAGES',

  FORMAT_LOCALE_KEY = 'FormatLocale.DefaultLocale',

  OFFLINE_LOCALE_KEY = 'OfflineLocale.DefaultLocale',

  PLAY_EARCONS = 'HTML.Application.PlayEarcons',

  PLAY_VISUAL_EFFECTS = 'HTML.Application.PlayVisualEffects',

  ENABLE_POPUP_DISPLAY_DURATION = 'HTML.Application.EnablePopupDisplayDuration',

  POPUP_DISPLAY_DURATION = 'HTML.Application.PopupDisplayDuration',

  INVERT_APP_COLORS = 'HTML.Application.InvertColors',

  ENABLE_KEYBOARD_TOOLTIPS = 'HTML.Application.EnableKeyboardToolTips',

  KEYBOARD_TOOLTIP_LOCATION = 'HTML.Application.KeyboardToolTipLocation',

  FOCUS_OVERRIDE = 'HTML.Application.FocusOverride',

  FOCUS_COLOR = 'HTML.Application.FocusColor',

  FOCUS_THICKNESS = 'HTML.Application.FocusThickness',

  FOCUS_OPACITY = 'HTML.Application.FocusAlpha',

  KEYBOARD_SHORTCUTS = 'HTML.KeyboardShortcuts',

  Avatar = 'Avatar',

  CONTENT_SELECTOR_COLUMN_ORDER = 'NOVA.ContentSelectorColumnOrder',
}

export const UI5_NO_COLOR_VALUE = 'NO_COLOR_VALUE';
